import { AgrDataSource, SortableDataSource, Sorting } from '@next/core-lib/table-v2';
import { BehaviorSubject, combineLatest, map, Observable, Subject } from 'rxjs';
import { FarmResource } from 'src/app/flock/models/flock.model';

export class FarmResourcesDataSource
  extends AgrDataSource<FarmResource>
  implements SortableDataSource<FarmResource>
{
  private readonly destroy$ = new Subject<void>();
  readonly sortingSubject = new BehaviorSubject<Sorting>({});

  constructor(public farmResources$: Observable<FarmResource[]>) {
    super();

    this.loadingSubject.next(false);
  }

  applySorting(sorting: Sorting): void {
    this.sortingSubject.next(sorting);
  }

  connect(): Observable<FarmResource[]> {
    return combineLatest([this.farmResources$, this.sortingSubject]).pipe(
      map(([resources, sorting]) => {
        const sortEntries = Object.entries(sorting);
        if (sortEntries.length > 0) {
          const [key, direction] = sortEntries[0];

          if (direction === '') {
            return resources;
          }

          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return resources.sort((a: any, b: any) => {
            const valueA = a[key];
            const valueB = b[key];
            const descending = direction === 'desc';

            if (valueA === null && valueB === null) return 0;
            if (valueA === null) return 1;
            if (valueB === null) return -1;

            if (typeof valueA === 'number' && typeof valueB === 'number') {
              return descending ? valueB - valueA : valueA - valueB;
            }

            return descending
              ? valueB.toString().localeCompare(valueA.toString())
              : valueA.toString().localeCompare(valueB.toString());
          });
        }

        return resources;
      }),
    );
  }

  disconnect(): void {
    if (!this.destroy$.closed) {
      this.destroy$.next();
      this.destroy$.complete();
    }
  }
}
